// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const armaldo: PokeData = {
  "id": 348,
  "name": "armaldo",
  "height": 15,
  "weight": 682,
  "base_experience": 173,
  "types": [
    PokeType.ROCK,
    PokeType.BUG
  ],
  "api_moves": [
    "scratch",
    "water-gun",
    "harden",
    "slash",
    "protect",
    "fury-cutter",
    "metal-claw",
    "ancient-power",
    "mud-sport",
    "crush-claw",
    "rock-blast",
    "brine",
    "x-scissor",
    "bug-bite",
    "smack-down"
  ],
  "moves": [
    "scratch",
    "protect",
    "metal-claw",
    "ancient-power",
    "rock-blast",
    "brine",
    "bug-bite",
    "sticky-web",
    "pounce",
    "pin-rush",
    "stone-crush",
    "heal-order",
    "string-shot"
  ],
  "evolution_chain": {
    "id": 177,
    "item": null,
    "species": [
      {
        "name": "anorith",
        "order": 375,
        "types": [
          PokeType.ROCK,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "armaldo",
        "order": 376,
        "types": [
          PokeType.ROCK,
          PokeType.BUG
        ],
        "evolves_from_species_id": 347,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 131,
    "speed": 71,
    "ability_power": 198
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
